<template>
  <div>
    <content-card :width="width">
      <template v-slot:header>
        <div class="title">{{ tm("send_report.wechat.header") }}</div>
      </template>
      <template v-slot:description>
        <div class="d-flex justify-content-center flex-column align-items-center g-24">
          <qrcode-vue :value="qrCodeLink" :size="qrWidth" :render-as="'svg'" />
          <div class="content text-center">{{ tm("send_report.wechat.description") }}</div>
          <button class="continue-button" @click="$emit('sendReport')">{{ t("button.continue") }}</button>
          <button class="continue-button-clear" @click="$emit('back')">{{ t("button.back") }}</button>
        </div>
      </template>
    </content-card>
  </div>
</template>

<script>
// https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb02d36ef1245acba&redirect_uri=https%3A%2F%2Ffwd-aidrinks.panoptic.ai%2F&response_type=code&scope=snsapi_base&state=U2FsdGVkX19xGqpZqukwYUKd5o3aN8KaQy2AD0pmia3jNDd2wdV7uwnBuSu8MudahqWRi89e8Hr1BUBQZKp2X7ac%2FhbjlM2hao9IpVEjr4rtLRUgFWLeSFZyZZG0Z8c7tsN7dK8f4%2FVQf0AB9S%2BFJC2bbFalOai6gsNoRpUNmrPyczrsg1FlD02GUWEGDqgomAPHFMPYLxege8Nx18SBN5jBCcqHCjf82c6TxOkiFRpYYGvRf6nNtVMTWqQxvVf5Q1wCFih8MtctzRcLdGp081c%2Bhg%2FtugEF6LHzMCXBVaGJHusNqVHEQ5FOkw7oOjSJ#wechat_redirect

import { useI18n } from "vue-i18n";
import QrcodeVue from "qrcode.vue";
export default {
  setup() {
    const { locale, t, tm } = useI18n();
    return {
      locale,
      t,
      tm,
    };
  },
  emits: ["back", "sendReport"],
  props: {
    qrCodeLink: String,
  },
  data() {
    return {
      qrWidth: 240,
      width: 80,
    };
  },
  components: {
    QrcodeVue,
  },
  mounted() {
    const adjustWidth = () => {
      if (window.innerWidth < 768) {
        this.qrWidth = 160;
        this.width = 100;
      } else {
        this.qrWidth = 240;
        this.width = 80;
      }
    };
    adjustWidth();
    this.$nextTick(() => {
      window.addEventListener("resize", adjustWidth);
    });
  },
};
</script>

<style scoped>.content {
  margin: 0 42px;
  font-size: 20px;
  font-weight: 500;
}
@media (max-width: 768px) {
  .content {
    margin: 0 24px;
    font-size: 14px;
  }
  
}
</style>
